const RESELLER_FLOW_APPS = [
  {
    appId: '2374b1f8-39ba-4d4c-bfd3-2fdec89ee4c4', // quickbooks
    productTypeId: '731bf458-a550-44f3-8b2f-3c45d712af06',
  },
];

export { RESELLER_FLOW_APPS };
